import { useEffect, useState } from "react";
import ApiClient from "../services/ApiClient";

export type PendingTasks = {
  scanCheckRequiredMediaObjectsCount: number;
  manualAttachmentMergeCount: number;
  activeBeaRetriesCount: number;
  bankPaymentsToCheckCount: number;
};

export const usePendingTasks = () => {
  const [pendingTasks, setPendingTasks] = useState<PendingTasks | null>(null);

  useEffect(() => {
    ApiClient.get("/dashboard/pending_tasks").then((pendingTaskResponse) => {
      setPendingTasks(pendingTaskResponse);
    });
  }, []);

  return pendingTasks;
};
